// import "@uswds/uswds/dist/js/uswds-init.js";
import banner from "@uswds/uswds/js/usa-banner";
import accordion from "@uswds/uswds/js/usa-accordion";

banner.on(document.body);
accordion.on(document.body);